module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cxjl"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', [_c('p', [_c('b', [_vm._v("时间：")]), _vm._v(" " + _vm._s(item.TIME) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("类别：")]), _vm._v(" " + _vm._s(item.TYPE) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("实施机关：")]), _vm._v(" " + _vm._s(item.SSJG) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("文号：")]), _vm._v(" " + _vm._s(item.WH) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("情况简介（200字以内）：")]), _vm._v(" " + _vm._s(item.QKJJ) + " ")]), _vm._v(" "), (_vm.list.length > 1) ? _c('div', {
      staticClass: "line"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "margin-b"
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-383af319"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/xxgs/nr/cxjl.vue
// module id = 879
// module chunks = 2